import { render, staticRenderFns } from "./DeliverSuccess.vue?vue&type=template&id=e772b53c&scoped=true&"
import script from "./DeliverSuccess.vue?vue&type=script&lang=js&"
export * from "./DeliverSuccess.vue?vue&type=script&lang=js&"
import style0 from "./DeliverSuccess.vue?vue&type=style&index=0&id=e772b53c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e772b53c",
  null
  
)

export default component.exports